import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, VStack } from '@chakra-ui/react';
import { LoadingFieldDropdown } from '@/components';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import config from '../../../../../config.json';

const PortingTypeField = ({ darkMode, values, setFieldValue, errors, touched, ufNumBlockPortingType, onError }) => {
  const [isHovered, setIsHovered] = useState(false);

  const portingOptions = values.companyID
    ? config.numbers.porting
    : [{ value: 0, name: 'None' }];

  return (
    <FormControl
      sx={{ margin: '0 !important' }}
      isInvalid={!!errors.numberBlockPortingType && touched.numberBlockPortingType}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
        <Box>
          <FormLabel sx={formLabelStyling(darkMode)}>
            Number Block Porting Type
          </FormLabel>
          <Text sx={descriptionStyling} maxWidth={250}>
            Select the porting type for this number block.
          </Text>
        </Box>
        <Box flex="1" minWidth="450px">
          <Box sx={{ display: 'flex', width: '100%', alignItems: 'flex-start', paddingTop: '15px' }}>
            <VStack width="100%" alignItems="normal">
              <LoadingFieldDropdown
                staticEnum={portingOptions}
                noEmptyOption
                fieldName=""
                dropDownValue="value"
                displayField="name"
                onChange={(v) => {
                  setFieldValue('numberBlockPortingType', v);
                }}
                fieldValue={values.numberBlockPortingType}
                toggleLimit={6}
                onError={onError}
                dataWalkthroughid={ufNumBlockPortingType}
              />
            </VStack>
          </Box>
        </Box>
        {isHovered && (
          <FieldToolTip
            label="Select the porting type for this number block."
            ariaLabel="porting-type-tip"
            left="25px"
            top="25px"
          />
        )}
      </Stack>
    </FormControl>
  );
};

export default PortingTypeField;